import { useQuery } from 'react-query';

import { enterpriseTotalAggragate, totalAggregateKey } from '@features/payments';
import axiosInstance from '@server/axiosInstance';

export const useGetTotalAggregate = () => {
  const {
    data: totalAggregate,
    isLoading: isLoadingTotalAggregate,
  } = useQuery({
    queryKey: [totalAggregateKey],
    queryFn: () =>
      axiosInstance
        .get(enterpriseTotalAggragate)
        .then((res) => res.data),
        enabled: true,
  });

  return {
    totalAggregate,
    isLoadingTotalAggregate,
  };
};
